/**
 * Shared login-status cookie visible to the public website (ph-website).
 *
 * Both QA and Prod sit on *.proudlyhuman.org, so the cookie is set on the
 * root domain. Environment is derived from the hostname at runtime:
 *   qa.app.proudlyhuman.org  -> ph_qa_logged_in
 *   app.proudlyhuman.org     -> ph_logged_in
 */

const QA_COOKIE_NAME = "ph_qa_logged_in";
const PROD_COOKIE_NAME = "ph_logged_in";
const ROOT_DOMAIN = ".proudlyhuman.org";

// 30 days — intentionally longer than a typical Auth0 session. If the session
// expires before the cookie, the user sees "Dashboard" but clicking it takes
// them to the web-app login page. LoginStatusCookieSync clears the cookie on
// any active session that becomes unauthenticated, so staleness only occurs if
// the browser state is lost (e.g. crash) without a clean logout.
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

function isOnProudlyHumanDomain() {
  const h = window.location.hostname;
  return h === "proudlyhuman.org" || h.endsWith(ROOT_DOMAIN);
}

function getCookieName() {
  return window.location.hostname.startsWith("qa.") ? QA_COOKIE_NAME : PROD_COOKIE_NAME;
}

function buildCookieBase(value: string, maxAge: number) {
  const name = getCookieName();
  const domain = isOnProudlyHumanDomain() ? `; Domain=${ROOT_DOMAIN}` : "";
  return `${name}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure${domain}`;
}

export function setLoginStatusCookie() {
  document.cookie = buildCookieBase("1", COOKIE_MAX_AGE);
}

export function clearLoginStatusCookie() {
  document.cookie = buildCookieBase("", 0);
}
